import { toast } from 'react-hot-toast';

type ToastMessages = {
  loading?: string;
  success?: string;
  error?: string;
};

export const usePromiseToast = () => {
  const triggerToast = async <T>(promise: Promise<T>, messages: ToastMessages = {}): Promise<T> => {
    const {
      loading = 'Carregando dados...',
      success = 'Dados carregados',
      error = 'Erro ao carregar dados.'
    } = messages;

    return toast.promise(promise, {
      loading,
      success,
      error,
    },{
      position: "bottom-left"
    });
  };

  return { triggerToast };
};


